import { WorkspaceAsset } from '@gripp/shared-logic';
import { StyleSheet, View } from 'react-native';
import openMap from 'react-native-open-maps';
import { Link } from '../crop-circle/Link';
import { ArrowTopRightAngleIcon, LocationIcon } from '../crop-circle/icons';
import { RoutineSubHeader } from './routineSubHeader';

type AssetDetailsProps = {
  workspaceAsset: WorkspaceAsset | undefined;
};

export const AssetDetails = (props: AssetDetailsProps) => {
  const { workspaceAsset } = props;

  if (!workspaceAsset) {
    return null;
  }

  const { asset } = workspaceAsset;
  const showSubHeader =
    workspaceAsset?.routineState && workspaceAsset.routineState.length > 0;

  return (
    asset && (
      <View style={styles.containerCropCircle}>
        <View style={styles.subHeaderContainer}>
          {showSubHeader && (
            <RoutineSubHeader workspaceAsset={workspaceAsset} />
          )}
        </View>
        {asset.lastAddress && (
          <View>
            <Link
              children={asset.lastAddress}
              underline={false}
              rightIcon={<ArrowTopRightAngleIcon size={12} />}
              leftIcon={<LocationIcon size={12} />}
              onPress={() =>
                openMap({
                  query: `${asset.lastLocation.coordinates[1]}, ${asset.lastLocation.coordinates[0]}`,
                })
              }
              emphasised={false}
              color="neutral"
              textStyle={{ fontWeight: '500' as const }}
              wrap
            />
          </View>
        )}
      </View>
    )
  );
};

const styles = StyleSheet.create({
  containerCropCircle: {
    flex: 1,
    // Allow this flex column to shrink below its content width (default is
    // minWidth: auto = content size) so the routine-pill row wraps within the
    // available space instead of forcing the column wider and overflowing.
    minWidth: 0,
    display: 'flex',
    justifyContent: 'space-between',
    // Fill the header by default (pins the address to the bottom) but grow past
    // it when the pills wrap onto extra rows. Matches the header's minHeight.
    minHeight: 88,
  },
  subHeaderContainer: {
    width: '100%',
  },
});
